<script setup>
import XlButton from '../xl/XlButton.vue';
import XlTooltip from '../xl/XlTooltip.vue';
import IconVideo from '../icons/IconVideo.vue';

/**
 * Join, on every upcoming session (XN-4558). Always shown; until 15 minutes
 * before the start (`joinable`) it is dimmed, does nothing and says why on
 * hover and focus. aria-disabled, not disabled: a disabled button gets no
 * hover or focus, so its tooltip could never show.
 */
defineProps({
  joinable: { type: Boolean, required: true },
  size: { type: String, default: 'sm', validator: (v) => ['sm', 'md'].includes(v) },
  label: { type: String, default: 'Join' },
  loading: { type: Boolean, default: false },
  speaker: { type: Boolean, default: false },
  title: { type: String, default: '' },
});
const emit = defineEmits(['join']);
</script>

<template>
  <!-- One tooltip around one button, so focus survives the room opening. -->
  <XlTooltip :text="joinable ? '' : 'The room opens 15 minutes before the session starts.'" control class="pjb">
    <XlButton
      :variant="speaker ? 'success' : 'filled'"
      :size="size"
      :loading="loading"
      :aria-disabled="joinable ? undefined : 'true'"
      :data-testid="joinable || !speaker ? 'join-call' : 'join-speaker-later'"
      @click="joinable && emit('join')"
    >
      <template #icon><IconVideo color="currentColor" size="15" /></template>
      {{ label }}<span v-if="title" class="pjb__sr">: {{ title }}</span>
    </XlButton>
  </XlTooltip>
</template>

<style scoped>
/* :hover too, so XlButton's own hover lift and shadow lose to it. */
.pjb :deep(.xl-btn[aria-disabled="true"]),
.pjb :deep(.xl-btn[aria-disabled="true"]:hover) { opacity: 0.5; cursor: not-allowed; transform: none; box-shadow: none; }
.pjb__sr {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden;
  clip: rect(0 0 0 0); white-space: nowrap; border: 0;
}
</style>
